import NavBar from './NavBar';

import AuthUserContext from '../../session/auth_user_context';

const Navigation = () => {
  return (
    <AuthUserContext.Consumer>
      {(value) => {
        const { authUser, userStatus } = value;

        return (
          <NavBar
            userStatus={userStatus}
            subscriptionType={authUser.subscriptionType}
          />
        );
      }}
    </AuthUserContext.Consumer>
  );
};

export default Navigation;
